import templateStr from 'text!./templates/language-expandos.html';
/**
 * Widget for displaying language expandos
 *
 * @returns {Object}
 */
export default (function () {
    return {
        restrict: 'A',
        replace: true,
        template: templateStr,
        controller: ['$scope', 'LocaleService', function ($scope, LocaleService) {
            $scope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
            $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
            $scope.isVisible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;
            $scope.isOpen = false;

            // METHODS
            $scope.changeLanguage = function (locale) {
                LocaleService.setLocaleByDisplayName(locale);
                $scope.currentLocaleDisplayName = locale;
            };
            $scope.toggleExpandos = function ($event) {
                $event.stopPropagation(); // we don't want to close the drawer
                $scope.isOpen = !$scope.isOpen;
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/l10n/directives/LanguageExpandosDirective.js
// module id = 1045
// module chunks = 0